import React from "react";
import {
  Input,
  Label,
  Button,
  Form,
  FormFeedback,
  Alert,
  Spinner,
} from "reactstrap";
import logoLight from "../../assets/images/LOGO_LUJ.png";

interface ChangePasswordFormProps {
  validationChangePassword: any;
  passwordShow: boolean;
  setPasswordShow: (show: boolean) => void;
  confirmPasswordShow: boolean;
  setConfirmPasswordShow: (show: boolean) => void;
  loader: boolean;
  passwordStrength: {
    text: string;
    color: string;
    width: string;
  };
}

const ChangePasswordForm: React.FC<ChangePasswordFormProps> = ({
  validationChangePassword,
  passwordShow,
  setPasswordShow,
  confirmPasswordShow,
  setConfirmPasswordShow,
  loader,
  passwordStrength,
}) => {
  return (
    <>
      <div className="text-center mt-2">
        <h5 className="text-black">Ubah Password</h5>
        <p className="text-muted">
          Ini adalah login pertama Anda. Silakan buat password baru.
        </p>
      </div>

      <Alert color="info" className="mt-3">
        <strong>Ketentuan Password:</strong>
        <ul className="mb-0 mt-2" style={{ fontSize: "0.875rem" }}>
          <li>Minimal 8 karakter</li>
          <li>Mengandung huruf besar (A-Z)</li>
          <li>Mengandung huruf kecil (a-z)</li>
          <li>Mengandung angka (0-9)</li>
          <li>Mengandung karakter khusus (@$!%*?&)</li>
        </ul>
      </Alert>

      <div className="p-2 mt-4">
        <Form
          onSubmit={(e) => {
            e.preventDefault();
            validationChangePassword.handleSubmit();
            return false;
          }}
        >
          <div className="mb-3">
            <Label className="form-label" htmlFor="newPassword">
              Password Baru
            </Label>
            <div className="position-relative auth-pass-inputgroup">
              <Input
                name="newPassword"
                value={validationChangePassword.values.newPassword || ""}
                type={passwordShow ? "text" : "password"}
                className="form-control pe-5"
                placeholder="Masukkan password baru"
                autoFocus
                onChange={validationChangePassword.handleChange}
                onBlur={validationChangePassword.handleBlur}
                invalid={
                  validationChangePassword.touched.newPassword &&
                  validationChangePassword.errors.newPassword
                    ? true
                    : false
                }
              />
              {validationChangePassword.touched.newPassword &&
              validationChangePassword.errors.newPassword ? (
                <FormFeedback type="invalid">
                  {validationChangePassword.errors.newPassword}
                </FormFeedback>
              ) : null}
              <button
                className="btn btn-link position-absolute end-0 top-0 text-decoration-none text-muted"
                type="button"
                tabIndex={-1}
                onClick={() => setPasswordShow(!passwordShow)}
              >
                <i className="ri-eye-fill align-middle"></i>
              </button>
            </div>

            {validationChangePassword.values.newPassword && (
              <div className="mt-2">
                <div className="d-flex justify-content-between mb-1">
                  <small>Kekuatan Password:</small>
                  <small className={`text-${passwordStrength.color}`}>
                    {passwordStrength.text}
                  </small>
                </div>
                <div className="progress" style={{ height: "5px" }}>
                  <div
                    className={`progress-bar bg-${passwordStrength.color}`}
                    role="progressbar"
                    style={{ width: passwordStrength.width }}
                  ></div>
                </div>
              </div>
            )}
          </div>

          <div className="mb-3">
            <Label className="form-label" htmlFor="confirmPassword">
              Konfirmasi Password Baru
            </Label>
            <div className="position-relative auth-pass-inputgroup">
              <Input
                name="confirmPassword"
                value={validationChangePassword.values.confirmPassword || ""}
                type={confirmPasswordShow ? "text" : "password"}
                className="form-control pe-5"
                placeholder="Masukkan ulang password baru"
                onChange={validationChangePassword.handleChange}
                onBlur={validationChangePassword.handleBlur}
                invalid={
                  validationChangePassword.touched.confirmPassword &&
                  validationChangePassword.errors.confirmPassword
                    ? true
                    : false
                }
              />
              {validationChangePassword.touched.confirmPassword &&
              validationChangePassword.errors.confirmPassword ? (
                <FormFeedback type="invalid">
                  {validationChangePassword.errors.confirmPassword}
                </FormFeedback>
              ) : null}
              <button
                className="btn btn-link position-absolute end-0 top-0 text-decoration-none text-muted"
                type="button"
                tabIndex={-1}
                onClick={() => setConfirmPasswordShow(!confirmPasswordShow)}
              >
                <i className="ri-eye-fill align-middle"></i>
              </button>
            </div>
          </div>

          <div className="mt-4">
            <Button
              color="danger"
              disabled={loader}
              className="btn btn-primary w-100"
              type="submit"
            >
              {loader && (
                <Spinner size="sm" className="me-2">
                  Loading...
                </Spinner>
              )}
              Ubah Password
            </Button>
          </div>

          <div className="mt-4 text-center">
            <div>
              <img src={logoLight} height="80" alt="Logo" />
            </div>
          </div>
        </Form>
      </div>
    </>
  );
};

export default ChangePasswordForm;
